import React, { Component } from 'react';
import { connect } from 'react-redux';
import DropzoneComponent from 'react-dropzone-component';
import _ from 'lodash';

import withForm from '../../../hoc/withForm/withForm';

import { fileList } from '../../../store/actions/file';

import CancelButton from '../../Buttons/CancelButton/CancelButton';
import SaveButton from '../../Buttons/SaveButton/SaveButton';

import validationRules from './validationRules/base';

import * as constants from '../../../constants';

class FileForm extends Component {
    state = {
        isUploading: false,
        dropZone: null,
        djsConfig: {
            addRemoveLinks: true,
            acceptedFiles: '',
            autoProcessQueue: false,
            maxFiles: 0,
            dictDefaultMessage: 'Click here or drag files to upload'
        },
        componentConfig: {
            allowedFiletypes: [],
            showFiletypeIcon: true,
            postUrl: 'no-url'
        }
    };

    componentWillMount() {
        let base_url = process.env.REACT_APP_WEBAPI_BASE;
        let acceptedFiles = 'image/jpeg,image/png,image/gif,application/pdf,text/plain,application/zip';
        let allowedFiletypes = ['.jpg', '.png', '.gif', '.pdf', '.txt', '.zip', '.jpeg'];
        let maxFiles = 10;

        if (process.env.REACT_APP_ENV === 'staging') {
            base_url = process.env.REACT_APP_WEBAPI_STAGING;
        } else if (process.env.REACT_APP_ENV === 'test') {
            base_url = process.env.REACT_APP_WEBAPI_TEST;
        } else if (process.env.REACT_APP_ENV === 'production') {
            base_url = process.env.REACT_APP_WEBAPI_PRODUCTION;
        }

        if (this.props.acceptedFiles != null) { acceptedFiles = this.props.acceptedFiles; }
        if (this.props.allowedFiletypes != null) { allowedFiletypes = this.props.allowedFiletypes; }
        if (this.props.maxFiles != null) { maxFiles = this.props.maxFiles; }

        let postUrl = base_url += (!_.isEmpty(this.props.postUrl)) ? this.props.postUrl : 'no-url';

        this.setState({
            djsConfig: {
                ...this.state.djsConfig, headers:
                {
                    'Authorization': `Bearer ${this.props.accessToken}`
                },
                acceptedFiles: acceptedFiles,
                maxFiles: maxFiles
            },
            componentConfig: { ...this.state.componentConfig, postUrl: postUrl, allowedFiletypes: allowedFiletypes }
        });
    };

    componentDidUpdate(prevProps) {
        if (this.props.lastState !== prevProps.lastState) {
            this.statusChanged(this.props.lastState);

            if (this.props.lastState === constants.STATE_FAIL) {
                this.props.formAlertFail(<span>File(s) could <strong>NOT</strong> be upload.</span>); // Action from HOC
            }
        }
    };

    cancelledHandler = () => {
        this.props.formCancelled(); // Action from HOC
    };

    uploadHandler = () => {
        this.setState({ isUploading: true });

        this.statusChangedHandler('uploading');

        this.dropZone.processQueue();
    };

    statusChangedHandler = (status, file, response) => {
        if (this.props.statusChanged) { this.props.statusChanged(status, file, response); }
    };

    uploadQueueCompleteHandler = () => {
        this.dropZone.removeAllFiles();

        this.setState({ isUploading: false });

        this.statusChangedHandler('queue-done');

        if (this.props.completed) { this.props.completed(); }
    };

    fileCompleteHandler = (file, response) => {
        this.statusChangedHandler('file-done', file, response);

        if (this.props.fileCompleted) { this.props.fileCompleted(file, response); }
    };

    maxFilesReachedHandler = () => {
        if (this.props.showMaxFilesReached) {
            this.props.formAlertFail(<span>You have reached the max number of files.</span>); // Action from HOC
        }
    };

    maxFilesExceededHandler = () => {
        this.props.formAlertFail(<span>You have exceeded the maximum allowed files to upload.</span>); // Action from HOC
    };

    uploadErrorHandler = () => {
        this.props.formAlertFail(<span>An error was encountered while trying to upload one of the files.</span>); // Action from HOC
    };

    render() {
        const isSaving = this.props.lastState === constants.STATE_PROCESSING || this.state.isUploading;
        const disabledProp = (isSaving) && { disabled: true };

        const eventHandlers = {
            init: (dz) => this.dropZone = dz,
            queuecomplete: () => this.uploadQueueCompleteHandler(),
            success: (file, response) => this.fileCompleteHandler(file, response),
            maxfilesreached: () => this.maxFilesReachedHandler(),
            maxfilesexceeded: () => this.maxFilesExceededHandler(),
            error: () => this.uploadErrorHandler()
        };

        return (
            <React.Fragment>
                <div className="file-uploader">
                    <DropzoneComponent config={this.state.componentConfig}
                        eventHandlers={eventHandlers}
                        djsConfig={this.state.djsConfig} />
                </div>
                {this.props.children}
                <hr className="form-divider" />
                <div className="form-action-buttons">
                    <CancelButton className="button-group-margin" text="Cancel" clicked={this.cancelledHandler} {...disabledProp} />
                    <SaveButton className="button-group-margin" text="Upload" savingText="Uploading..." saving={isSaving} clicked={this.uploadHandler} {...disabledProp} />
                </div>
            </React.Fragment>
        );
    }
};

const mapStateToProps = (state) => ({
    file: state.file.file,
    isNew: state.file.isNew,
    lastState: state.file.lastState,
    lastScope: state.file.lastScope,
    franchise: state.franchise.franchise,
    mlsProvider: state.mlsProvider.mlsProvider,
    files: state.file.files,
    accessToken: state.authentication.accessToken
});

const mapDispatchToProps = (dispatch) => ({
    onFileList: () => dispatch(fileList())
});

export default connect(mapStateToProps, mapDispatchToProps)(withForm(FileForm, validationRules));
